import {Component, OnInit, Inject} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';
import {APP_CONFIG} from '@synthroneApp/app.config';
import {MatDialog} from '@angular/material';
import {ComponentModel} from '@synthroneApp/models/component/component.model';
import { ClientServiceSDK } from 'ms-client-angular-sdk';

@Component({
    selector: 'app-component-add-view',
    templateUrl: './component-add-view.component.html',
    styleUrls: ['./component-add-view.component.scss']
})

export class ComponentAddViewComponent implements OnInit {

    dataId: number;
    isLoading = true;
    actionName: string;

    sections: any;
    categories: any;
    clients: any;
    isDataLoading = false;

    public component: ComponentModel;

    constructor(
        private _router: Router, 
        protected api: ApiService,
        private messagesService: MessagesService, 
        @Inject(APP_CONFIG) private config, 
        protected dialog: MatDialog, 
        private clientService: ClientServiceSDK) {
        this.actionName = (this._router.url.includes('add') ? 'Add' : 'Edit');
    }

    ngOnInit() {
        this.sections = [];
        this.categories = [];
        this.clients = [];

        this.component = {
            name: '',
            title: '',
            usageLimit: 1,
            componentType: '',
            version: 1,
            categories: '',
            sections: '',
            clients: '',
        };

        this.api.makeRequest('api_system_section_list', {}, 'crafter').catch(
            (err: any) => {
                const errorMsg = err || 'Could not get list of sections';
                return Observable.throw(errorMsg)
            }).subscribe(
            (result: any) => {
                this.sections = result.data;

                this.api.makeRequest('api_system_category_list', {}, 'crafter').catch(
                    (err: any) => {
                        const errorMsg = err || 'Could not get list of categories';
                        return Observable.throw(errorMsg)
                    }).subscribe(
                    (result2: any) => {
                        this.categories = result2.data;

                        this.api.makeSDKRequest(this.clientService, "clientsGet").subscribe(
                            (result3: any) => {
                                this.clients = result3.data;

                                if (this.actionName === 'Edit') {
                                    this.dataId = parseInt((this._router.url).match(/\d+/)[0]);

                                    this.api.makeRequest('api_system_component_details', {
                                        id: this.dataId
                                    }, 'crafter').subscribe(
                                        (result4: any) => {

                                            const categories = result4['categories'].map(function (cit) { return cit.id; });
                                            const sections = result4['sections'].map(function (sit) { return sit.id; });
                                            const clients = result4['clients'].map(function (clit) { return clit.planet; });

                                            if(result4['name']){
                                                this.component.name = result4['name'];
                                            }
                                            if(result4['title']){
                                                this.component.title = result4['title'];
                                            }
                                            if(result4['usageLimit'] != undefined && result4['usageLimit'] !== null){
                                                this.component.usageLimit = result4['usageLimit'];
                                            }
                                            if(result4['type']){
                                                this.component.componentType = result4['type'];
                                            }
                                            if(result4['version']){
                                                this.component.version = result4['version'];
                                            }
                                            this.component.categories = categories;
                                            this.component.sections = sections;
                                            this.component.clients = clients;

                                            this.isLoading = false;
                                        },
                                        (error) => {
                                            this.isLoading = false;
                                            this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                                                this.homeReturnFN();
                                            });
                                        });
                                } else {
                                    this.isLoading = false;
                                }
                            },
                            (error) => {
                                this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result3Err => {
                                    this.homeReturnFN();
                                });
                            });
                    },
                    (error) => {
                        this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result2Err => {
                            this.homeReturnFN();
                        });
                    });
            },
            (error) => {
                this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(resultErr => {
                    this.homeReturnFN();
                });
            });

    }

    homeReturnFN = () => {
        this._router.navigate(['/components']);
    };

    createFN = () => {
        this.api.makeRequest('api_system_component_add', this.component, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this._router.navigate(['/components/edit', result['id'], 'variants']);
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    editFN = () => {
        this.isLoading = true;
        this.component.id = this.dataId;
        this.api.makeRequest('api_system_component_edit', this.component, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    submitFN(isValid: boolean) {
        if (this.actionName === 'Add') {
            this.createFN();
        } else {
            this.editFN();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/views/component-add-view/component-add-view.component.ts